import { TextSkeleton } from "@imi/ui/components/Skeleton/Skeleton.js";
import { OutputField } from "@src/routes/projects/$projectId/selections/components/OutputField";
import { TechnicalSelectionOutput } from "@src/routes/projects/$projectId/selections/hooks/useBuildSuggestionOutput";
import { get } from "radashi";
import { BatchSelectionRow } from "../../../../store/types";
import styles from "./BatchOutputCell.module.css";

type BatchOutputCellProps = {
  column: string;
  row: BatchSelectionRow;
};

export function BatchOutputCell({ column, row }: BatchOutputCellProps) {
  if (row.output.status === "loading") {
    return <TextSkeleton />;
  }

  const isOutput = column.startsWith("output");
  if (isOutput) {
    const match = get<TechnicalSelectionOutput>(
      row.output.suggestion?.output,
      column.split(".").pop() ?? "",
    );
    if (!match) return "";
    return (
      <OutputField
        alignTooltip="center"
        className={styles.OutputField}
        output={match}
      />
    );
  }

  const isPipe = column.startsWith("pipeResult");
  if (isPipe) {
    const match = get<TechnicalSelectionOutput>(
      row.output.pipeResult,
      column.split(".").pop() ?? "",
    );
    if (!match) return "";
    return (
      <OutputField
        alignTooltip="center"
        className={styles.OutputField}
        output={match}
      />
    );
  }

  return get<string>(row.output.suggestion, column) ?? "";
}
